import { getRemainingMonthsInYear, isDefined, numberOrZero } from "@/utils/utils";
import { Button, Popover } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LabelWithPopover from "../../../../../../common/components/form/labels/LabelWithPopover";
import { formatLocaleNumber } from "../../../../../../common/utils/formatUtils";
import { tInterval } from "../../../../../../common/utils/translationUtils";
import { UUID } from "../../../../../../typings/global";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";
import { AddGoalModal } from "../modals/AddGoalModal";
import { isCreatedGoal } from "../utils";

type Props = {
  goal?: DashboardGoal;
  year: number;
  agentId: UUID;
};

export const TipperPointsWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const [isOpenSetGoalModal, setIsOpenSetGoalModal] = useState(false);

  const hasTarget = isDefined(goal?.targetValue);
  const actualValue = numberOrZero(goal?.actualValue);
  const targetValue = numberOrZero(goal?.targetValue);

  const currentPercentage = isCreatedGoal(goal) ? getPercentage(actualValue, targetValue) : 0;
  const isGoalCompleted = currentPercentage >= 100;

  const remainingMonths = getRemainingMonthsInYear(dayjs());
  const remainingMonthsAveragePoints =
    remainingMonths > 0 && !isGoalCompleted ? Math.ceil((targetValue - actualValue) / remainingMonths) : 0;

  return (
    <>
      <GoalCard
        agentId={agentId}
        year={year}
        goal={goal}
        percentage={currentPercentage}
        isGaugeStyle
        label={
          hasTarget ? (
            <div className="center-align">
              <Popover content={t("dashboard.goals.helpers.pointsGoalHint")}>
                {t("dashboard.enums.dashboardGoalType.TIPPER_POINTS")}
              </Popover>

              {hasTarget && !isGoalCompleted && year === dayjs().year() ? (
                <LabelWithPopover
                  style={{ fontSize: 14, display: "block", whiteSpace: "nowrap" }}
                  popoverContent={t("dashboard.goals.helpers.pointsByMonthHint")}
                  label={
                    <p style={{ fontSize: 16, fontWeight: 400, display: "inline-block", marginRight: 4 }}>
                      {remainingMonthsAveragePoints}{" "}
                      {tInterval("dashboard.goals.helpers.points_interval", remainingMonthsAveragePoints)}{" "}
                      {t("dashboard.goals.helpers.monthly")}
                    </p>
                  }
                />
              ) : undefined}
            </div>
          ) : (
            <Button onClick={() => setIsOpenSetGoalModal(true)}>{t("dashboard.goals.actions.setTarget")}</Button>
          )
        }
        hasTarget={hasTarget}
        targetLabel={
          hasTarget ? undefined : (
            <div style={{ color: "white" }}>
              <div>{formatLocaleNumber(actualValue)}</div>

              <span style={{ fontSize: 16 }}>
                {tInterval("dashboard.goals.helpers.points_interval", Math.abs(actualValue))}
              </span>
            </div>
          )
        }
        tooltipTitle={
          hasTarget ? (
            <p>
              {actualValue} {tInterval("dashboard.goals.helpers.points_interval", Math.abs(actualValue))}{" "}
              {t("dashboard.goals.helpers.from")} {targetValue}
            </p>
          ) : undefined
        }
      />

      {goal && agentId ? (
        <AddGoalModal
          isOpen={isOpenSetGoalModal}
          onCancel={() => setIsOpenSetGoalModal(false)}
          goalType={goal.type}
          year={year}
          agentId={agentId}
        />
      ) : undefined}
    </>
  );
};
